module.exports = __webpack_public_path__ + "static/media/bg-light-2.16263cb5.png";